(function () {

function hide_menu_gift_cards() {
  if (window_api_data.country == 'AUS') {
    return;
  }

  const menus = document.querySelectorAll('#header-panel-2 .header-sidebar__linklist, .footer__block-list ul');

  for (let i = 0; i < menus.length; i++) {
    const menu_items = menus[i].querySelectorAll('li');
    for (let j = 0; j < menu_items.length; j++) {
      const link = menu_items[j].querySelector('a');
      if (link && link.innerText.trim() === 'Gift Cards') {
        menu_items[j].style.display = 'none';
      }
    }
  }
}

window.hide_menu_gift_cards = hide_menu_gift_cards;

})();

